import { AppBar, Box, Toolbar } from '@material-ui/core';

import { NavBar } from 'common/components';
import { NavBarStyles } from 'common/components/templates/NavBar/styles';
import { AstropayLogo } from 'common/config/assets';
import { useAppSelector } from 'common/helpers/hooks';
import { getIsSdk, getMobileSdk } from 'common/store/global';

export const AuthenticationNav = () => {
  const isSdk = useAppSelector(getIsSdk);
  const isMobile = useAppSelector(getMobileSdk);
  const classes = NavBarStyles();

  if (isSdk && isMobile) {
    return (
      <AppBar className={classes.root} elevation={0} style={{ border: 'none' }}>
        <Box display="flex" flex="1" padding={1}>
          <Toolbar
            className={classes.toolbar}
            style={{ justifyContent: 'flex-start' }}
            disableGutters
          >
            <Box display="flex">
              <img src={AstropayLogo} alt="AstroPay" style={{ maxWidth: '95px' }} />
            </Box>
          </Toolbar>
        </Box>
      </AppBar>
    );
  }

  return <NavBar />;
};
